export default {
  state: {
    keepaliveRoutes: [],
  },
  mutations: {
    ADD_KA_ROUTES(state, routeName) {
      if (state.keepaliveRoutes.indexOf(routeName) === -1)
        state.keepaliveRoutes.push(routeName);
    },
    DELETE_KA_ROUTES(state, routeName) {
      const target = state.keepaliveRoutes.indexOf(routeName);
      if (target !== -1) state.keepaliveRoutes.splice(target, 1);
    },
    CLEAR_KA_ROUTES(state) {
      state.keepaliveRoutes = [];
    },
  },
};
